<template>
  <div class="main-conent main-conent-maxheight main-content-rows">
    <search
      @date-change="dateChange"
      @export="exportExcel"
      @type-change="showTypeChange"
    ></search>

    <el-row v-show="showType === 'preview'" :gutter="20">
      <el-col :span="8">
        <el-table
          v-if="reload"
          v-loading="loadingStatic"
          class="box-card"
          style="padding:0;"
          stripe
          border
          :data="analysis"
          :height="342"
        >
          <el-table-column
            prop="name"
            label="终端"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="todayCount" label="今日"></el-table-column>
          <el-table-column prop="count" label="昨日"></el-table-column>
          <el-table-column prop="sum" label="30天"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="16">
        <div
          class="box-card no-hidden"
          v-loading="loadingPreview || loadingStatic"
        >
          <echart
            v-if="reload"
            chartId="meteorology"
            :options="options"
            :height="height - 100"
          ></echart>
        </div>
      </el-col>
    </el-row>

    <el-row v-show="showType === 'data'">
      <el-col>
        <el-table
          v-if="reload"
          v-loading="loadingPreview"
          ref="table"
          stripe
          border
          :max-height="600"
          :data="summary"
        >
          <el-table-column prop="date" label="时间"></el-table-column>
          <el-table-column prop="device" label="终端"></el-table-column>
          <el-table-column prop="insect" label="诱芯类别"></el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment'
import Search from './components/search'
import Echart from '@/components/Chart'
import { getStatistic, getPreview } from '@/service/trap'
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'
import sleep from '@/utlis/sleep'

export default {
  components: { Echart, Search },
  data() {
    return {
      reload: true, // 用于刷新 el-table 高度
      loading: false,
      loadingPreview: false,
      loadingStatic: false,
      showType: 'preview',
      height: 400, // 内容的高度
      date: new Date(),
      begin: moment()
        .startOf('week')
        .format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD'),
      analysis: [],
      summary: [],
      dateType: 'thirtyDays',
      query: {},
      menus: []
    }
  },
  computed: {
    xAxis() {
      const { begin, end } = this
      const bm = moment(begin)
      const em = moment(end)
      let xAxis = [bm.format('YYYY-MM-DD')]
      let current = moment(begin)

      while (current.isBefore(em)) {
        current = current.add(1, 'd')
        xAxis.push(current.format('YYYY-MM-DD'))
      }
      return xAxis
    },
    options() {
      let { summary, analysis, xAxis } = this
      return {
        legend: { show: true },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        position: function(pos, params, el, elRect, size) {
          var obj = { top: -80 }
          obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30
          return obj
        },
        series: analysis.map(d => {
          const data = summary.filter(o => o.deviceId === d.id)
          return {
            name: d.name,
            type: 'bar',
            data: xAxis.map(x => {
              const cells = data.filter(l => l.date === x)
              return cells.reduce((total, cur) => (total += cur.count), 0)
            })
          }
        })
      }
    },
    tableData() {
      return this.traps.map(t => {
        let data = this.summary.filter(s => s.deviceId === t.id)
        return data.reduce(
          (ret, cur) => {
            ret.sum += cur.count
            ret.min = Math.min(ret.min || 0, cur.count)
            ret.max = Math.max(ret.max || 0, cur.count)
            return ret
          },
          { sum: 0, name: t.name, min: 0, max: 0 }
        )
      })
    }
  },
  async mounted() {
    this.loading = true
    await Promise.all([this.getData(), this.getPreview(this.begin, this.end)])
    this.loading = false
  },
  methods: {
    async getData() {
      this.loadingStatic = true
      const [{ data }] = await Promise.all([
        getStatistic(this.companyId),
        sleep(1)
      ])
      this.loadingStatic = false
      this.analysis = data
    },
    async getPreview(begin, end) {
      this.loadingPreview = true
      const [{ data }] = await Promise.all([
        getPreview({
          companyId: this.companyId,
          begin,
          end
        }),
        sleep(1)
      ])
      this.loadingPreview = false
      this.summary = data
    },
    async dateChange(begin, end) {
      this.loading = true
      this.begin = begin
      this.end = end
      await this.getPreview(begin, end)
      this.loading = false
    },
    showTypeChange(type) {
      this.showType = type
    },
    exportExcel() {
      exceljs(this.$refs.table.$el, '诱捕器数据汇总')
    }
  },
  watch: {
    // 监控高度刷新 el-table 高度
    height() {
      this.reload = false
      this.$nextTick(() => {
        this.reload = true
      })
    }
  }
}
</script>

<style scoped>
.no-hidden {
  overflow: visible;
}
</style>
